

import { Row, Col, Badge } from 'react-bootstrap';
import StaticMap from './StaticMap.js';
import StationLinker from './StationLinker';

import { FMRainfallStation } from './FloodMapperIcons.js';

function capitalizeFirstLetter(val) {
  if (!val) {
    return null;
  }

  return String(val)
    .split(' ') // Split the string into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(' '); // Join the words back into a string
}

function RainfallMultiStationSummary({ stations, summaryType = 'catchment' }) {

	const outputDateOpts = {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false
	};

	const outputDateOnlyOpts = {
		month: 'short', day: '2-digit'
	};

	const dateRowSnippet = function(title, totalAmount, periodStart, periodEnd) {
		const todayDate = new Date().toLocaleDateString(undefined, outputDateOnlyOpts);
		const startDate = new Date(periodStart).toLocaleDateString(undefined, outputDateOnlyOpts);
		const endDate = new Date(periodEnd).toLocaleDateString(undefined, outputDateOnlyOpts);
		const isStartToday = todayDate === startDate;
		const isEndToday = todayDate === endDate;


		return <Row>
			<Col xs={12}><b>{title}</b></Col>
		<Col xs={12}>
				<Badge bg="dark">
					{isNaN(parseFloat(totalAmount)) ? "-" : parseFloat(totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} mm
				</Badge>
			</Col>
			<Col xs={12} style={{fontSize: "0.65em"}}><b><i>{(new Date(periodStart)).toLocaleString(undefined, outputDateOpts)}{isStartToday ? "" : <span> ({startDate})</span>}-{(new Date(periodEnd)).toLocaleString(undefined, outputDateOpts)}{isEndToday ? "" : <span> ({endDate})</span>}</i></b></Col>
		</Row>;
	}

	let stnComponentsToRender = (stations || []).reduce(function(acca, station) {
		if(station.metricType === 'Rainfall') {
			acca.push(<Row key={"rfsum_" + station.stationId + "_" + station.metricId}>
				<Col xs={12} className="bg-secondary text-white"><b>{station.stationName}</b></Col>
				<Col xs={4} md={2}  className="g-0">
					<StationLinker stationId={station.stationId} urlSlug={station.urlSlug} metricId={station.metricId} metricQualifier={station.metricType}>
						<StaticMap
							style={{width: "100%", height: "100%", minHeight: "81px"}}
							lat={station.lat}
							lng={station.lng}
							label={"Rainfall at " + station.stationName}
							inhibitAttribForTinySize={true}
							noPopup={true}
						/>
					</StationLinker>
				</Col>
				<Col xs={8} md={10}>
					<Row>
						<Col xs={12} md={3}>
							{dateRowSnippet('3h Total', station.total3Hours, station.window3Hours, station.mostRecentData)}
						</Col>
						<Col xs={12} md={3}>
							{dateRowSnippet('6h Total', station.total6Hours, station.window6Hours, station.mostRecentData)}
						</Col>
						<Col xs={12} md={3}>
							{dateRowSnippet('12h Total', station.total12Hours, station.window12Hours, station.mostRecentData)}
						</Col>
						<Col xs={12} md={3}>
							{dateRowSnippet('24h Total', station.total24Hours, station.window24Hours, station.mostRecentData)}
						</Col>
					</Row>
					<Row>
						{station.max24Hours && station.max24Hours > 0 ? 
							<Col xs={12} style={{borderTop: "1px dotted grey"}}>
								<b><i>Last 24h: Max 15m intensity at {(new Date(station.maxTotalTimestamp)).toLocaleString(undefined, outputDateOpts)} ({new Date(station.maxTotalTimestamp).toLocaleDateString(undefined, outputDateOnlyOpts)})</i></b> <Badge bg="dark">{isNaN(parseFloat(station.max24Hours)) ? '-' : parseFloat(station.max24Hours).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} mm</Badge></Col> :
							<Col xs={12} style={{borderTop: "1px dotted grey"}}>
								<i>No rainfall logged in the 24h period</i>
							</Col>}
					</Row>
				</Col>
			</Row>);
		}

		return acca;
	}, []);


	if(stnComponentsToRender.length === 0) {
		stnComponentsToRender.push(<span>No rainfall data to display in this {summaryType}</span>);
	}

	return <Row>
		<Col xs={12} className="bg-dark text-white d-flex align-items-center fm-rounded-box-top">
  <span className="mx-auto" style={{ textAlign: "center" }}>
    {capitalizeFirstLetter(summaryType)} Rainfall Summary
  </span>

  {/* Snap FMRainfallStation to the right */}
  <FMRainfallStation style={{
    fontSize: "1.1em", 
    position: "absolute", 
    right: "10px", // Adjust distance from the right as needed
  }} />
</Col>

		<Col xs={12} className="fm-rounded-box-bottom">{stnComponentsToRender}</Col>
	</Row>;
}

export default RainfallMultiStationSummary;

